import * as React from 'react';
import { ReactNode, useContext } from 'react';
import { AuthContext } from '../Auth/components/AuthProvider';
import { Navigate } from 'react-router';
import { UserRole } from '../util/types';

interface Props {
  roles?: UserRole[];
  children: React.ReactNode;
}

export const ProtectedRoute = (props: Props): ReactNode => {
  const {session} = useContext(AuthContext);
  if (!session) {
    sessionStorage.setItem('target_path',window.location.pathname);
    return <Navigate to={'/login'} replace={true}/>;
  }
  if (props.roles && props.roles.length > 0 && !props.roles.some(((role: string): boolean => session.roles.includes(role)))) {
    return <Navigate to={'/'} replace={true}/>;
  }
  return props.children;
};
